import styled from 'styled-components'

import { CommonTextProps, commonTextStyle, } from '../utils'

export default styled.span<CommonTextProps>`
  ${ commonTextStyle }
`
